import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { money } from '../api'
import { useBag } from '../store'

export function Bag() {
  const { cart, update, remove, applyPromo, busy } = useBag()
  const [code, setCode] = useState('')
  const [promoErr, setPromoErr] = useState('')
  const nav = useNavigate()
  const items = cart?.items ?? []
  if (items.length === 0) {
    return (
      <div className="container empty" data-testid="bag-empty">
        <h1>Your bag is empty.</h1>
        <p>Nothing in here yet — let's put something together.</p>
        <Link to="/women" className="btn">Shop women</Link>{' '}
        <Link to="/men" className="btn ghost" style={{ marginLeft: 8 }}>Shop men</Link>
      </div>
    )
  }
  const subtotal = cart!.subtotal_cents
  const discount = cart!.promo === 'FALL30' ? Math.round(subtotal * 0.3) : cart!.promo ? Math.round(subtotal * 0.1) : 0
  const shipping = subtotal - discount >= 7500 ? 0 : 695
  const tax = Math.round((subtotal - discount) * 0.07)
  return (
    <div className="container">
      <div className="crumbs"><Link to="/">Home</Link> / Bag</div>
      <h1 style={{ fontSize: 'clamp(28px,3.5vw,44px)' }}>Your bag</h1>
      <div className="bag">
        <div>
          {items.map(it => (
            <div className="line" key={it.line_id} data-testid="bag-line">
              <img src={it.image} alt="" />
              <div>
                <div className="name">{it.name}</div>
                <div className="var">{it.color} · Size {it.size}</div>
                <div className="qty"><button onClick={() => update(it.line_id, it.qty - 1)} disabled={busy} aria-label="Decrease">−</button><span>{it.qty}</span><button onClick={() => update(it.line_id, it.qty + 1)} disabled={busy} aria-label="Increase">+</button></div>
                <button className="remove" onClick={() => remove(it.line_id)} disabled={busy}>Remove</button>
              </div>
              <div>{money(it.price_cents * it.qty)}</div>
            </div>
          ))}
          <p style={{ marginTop: 18 }}><Link to="/women" className="link">Continue shopping</Link></p>
        </div>
        <aside className="summary">
          <h3>Order summary</h3>
          <div className="row"><span>Subtotal</span><span data-testid="subtotal">{money(subtotal)}</span></div>
          {discount > 0 && <div className="row" style={{ color: 'var(--success)' }}><span>Promo {cart!.promo}</span><span>−{money(discount)}</span></div>}
          <div className="row"><span>Shipping</span><span>{shipping === 0 ? 'Free' : money(shipping)}</span></div>
          <div className="row"><span>Estimated tax</span><span>{money(tax)}</span></div>
          <div className="row total"><span>Total</span><span data-testid="total">{money(subtotal - discount + shipping + tax)}</span></div>
          <form className="promo" onSubmit={async e => { e.preventDefault(); setPromoErr(''); try { await applyPromo(code.trim().toUpperCase()); setCode('') } catch { setPromoErr('That code isn’t valid.') } }}>
            <input className="input" placeholder="Promo code" value={code} onChange={e => setCode(e.target.value)} aria-label="Promo code" data-testid="promo-code" />
            <button className="btn ghost" type="submit" disabled={!code || busy}>Apply</button>
          </form>
          {promoErr && <div className="field"><div className="hint">{promoErr}</div></div>}
          <button className="btn accent block" style={{ marginTop: 14 }} data-testid="checkout-cta" onClick={() => nav('/checkout')}>Checkout</button>
          <p className="secure">Secure checkout · Free returns within 30 days</p>
        </aside>
      </div>
    </div>
  )
}
